<template>
  <tr>
    <!-- <td>
      <img v-if="comercio.imagen != null" :src="imagenRuta" :alt="`${comercio.nombre}`">
      <img v-else src="@/assets/image-not-available.jpg" :alt="`${comercio.nombre}`">
    </td> -->
    <td>{{ servicio.nombre }}</td>
    <td>{{ servicio.descripcion }}</td>
    <td>{{ servicio.categoria }}</td>
    <td>{{ servicio.precio_no_socio }}</td>
    <td>{{ servicio.moneda }}</td>
    <td>
      <ul>
        <ServiciosListaItemCuota
          v-for="cuota in servicio.cuotas"
          :cuota="cuota"
          :key="cuota.cuota_id"
        ></ServiciosListaItemCuota>
      </ul>
    </td>
    <td>
      <div class="contenor_botones_form_stock">
        <router-link :to="`/editar-servicio/${servicio.servicio_id}`" class="boton-editar">Editar</router-link>
        <button @click="borrarServicio(servicio.servicio_id)" class="boton-borrar">Borrar</button>
      </div>
    </td>
    <!-- <td class="botones-acciones"> -->
      <!-- <div class="botones-acciones-contenedor"> -->
        <!-- <button @click="abrirModal(profesor.persona_id)" class="icon icon-trash-o boton-acciones">Dar de Baja</button> -->
      <!-- </div> -->
      <!-- <div :class="`confirmation-${profesor.persona_id}`" class="confirmation">
        <div class="contenor_modal">
          <p>¿Estas seguro que deseas dar de baja a {{ profesor.nombre }} {{ profesor.apellido }}</p>
          <div class="contenor_modal_botones">
            <button @click="cerrarModal(profesor.persona_id)" class="boton_cancelar boton_modal">CANCELAR</button>
            <button @click="bajaProfesor(profesor.persona_id)" :data-id="`${profesor.persona_id}`" class="boton_aceptar boton_modal">ACEPTAR</button>
          </div>
        </div>
      </div> -->
    <!-- </td> -->
  </tr>
</template>

<script>
import ServiciosListaItemCuota from '../components/ServiciosListaItemCuota.vue'
import serviciossService from '../services/servicios'
export default {
  name: 'ServiciosListaItem',
  components: {
    ServiciosListaItemCuota
  },
  props: ['servicio'],
  data: function () {
    return {
      // store
    }
  },
  methods: {
    borrarServicio (id) {
      console.log(id)
      serviciossService
        .borrarServicio(id)
        .then(respuesta => {
          this.$emit('refrescar')
        })
    },
    abrirModal (id) {
      console.log(id)
      const confirmation = document.querySelector('.confirmation-' + id)
      confirmation.style.display = 'flex'
    },
    cerrarModal (id) {
      const confirmation = document.querySelector('.confirmation-' + id)
      confirmation.style.display = 'none'
    }
    // tipo (tipo) {
    //   switch (tipo) {
    //     case 1:
    //       return 'comercio_tipo_restaurant'
    //     case 2:
    //       return 'comercio_tipo_hotel'
    //     case 3:
    //       return 'comercio_tipo_bar'
    //   }
    //   return 'comercio_tipo_restaurant'
    // }
  },
  computed: {
    // imagenRuta: function () {
    //   return `${PATH_IMG}/${this.comercio.imagen}`
    // }
  }
}
</script>
